import React from "react";
import {Route} from "react-router-dom";
import * as ROUTES_CONSTANTS from "../../utils/constants/RoutesConstants";
import VentanillaContainer from "../../pages/ventanilla";
import EdicionPostura from "../../pages/edicionPostura";
import LogContainer from "../../pages/admin/log/LogContainer";
import OrderAdminContainer from "../../pages/operation/orderAdmin"
import ExtensionAdminContainer from "../../pages/operation/extensionAdmin";
import AvailableValuesFidContainer from "../../pages/availableValuesFid";
import SettlementContainer from "../../pages/operation/settlement";
import CloseContainer from "../../pages/operation/close";
import LoanableValues from "../../pages/loanableValues";
import ControlPanelContainer from "../../pages/controlPanel";
import InvoiceContainer from "../../pages/admin/invoice";
import CaptureGuarantees from "../../pages/ptt/captureGuarantees";
import CorporateActionContainer from "../../pages/corporateAction";
import EmailAdminContainer from "../../pages/emailAdmin";
import TrustPositionContainer from "../../pages/trustPosition";
import CapacityContainer from "../../pages/capacity";
import UserContainer from "../../pages/user";
import ValuesRequest from "../../pages/ptt/valuesRequest";
import MaintenanceAccounts from "../../pages/maintenanceAccounts";
import ContractOTC from "../../pages/contractOTC";
import OperationAmount from "../../pages/limitControl/amountOperation";
import GuaranteesTables from "../../pages/limitControl/guaranteesTable";
import CapacityTable from "../../pages/limitControl/capacityTable";
import MaintenanceInstitutionContainer from "../../pages/maintenance/institution";
import MaintenanceSchedule from "../../pages/maintenance/schedule";
import ClientGSS from "../../pages/maintenance/clientGSS";
import AvailableLend from "../../pages/availableLend";
import MaintenanceUsers from "../../pages/maintenance/users";
import MaintenanceDomains from "../../pages/maintenance/domains";
import CaptureLoanableValues from "../../pages/ptm/captureLoanableValues";
import GuaranteeSelection from "../../pages/limitControl/guaranteeSelection";
import ValueTypeContainer from "../../pages/maintenance/valueType";
import MaintenanceInstrument from "../../pages/maintenance/instrument"
import CustodiaBanamex from "../../pages/custodia";
import CustodiaBBVA from "../../pages/custodiaBBVA";
import CustodiaTitulos from "../../pages/maintenance/custodiaTitulos";
import BilateralContract from "../../pages/bilateral/contract";


const MenuRoutes = () => {
    return (
        <React.Fragment>
            <Route path={ROUTES_CONSTANTS.VENTANILLA_ROUTE} component={VentanillaContainer}/>
            <Route path={ROUTES_CONSTANTS.EDICION_POSTURA_ROUTE} component={EdicionPostura}/>
            <Route path={ROUTES_CONSTANTS.LOG_ROUTE} component={LogContainer}/>
            <Route path={ROUTES_CONSTANTS.VALUE_TYPES_ROUTE} component={ValueTypeContainer}/>
            <Route path={ROUTES_CONSTANTS.ORDER_ADMIN_ROUTE} component={OrderAdminContainer}/>
            <Route path={ROUTES_CONSTANTS.EXTENSION_ADMIN_ROUTE} component={ExtensionAdminContainer}/>
            <Route path={ROUTES_CONSTANTS.AVAILABLE_VALUES_FID_ROUTE} component={AvailableValuesFidContainer}/>
            <Route path={ROUTES_CONSTANTS.SETTLEMENT_ROUTE} component={SettlementContainer}/>
            <Route path={ROUTES_CONSTANTS.CLOSE_ROUTE} component={CloseContainer}/>
            <Route path={ROUTES_CONSTANTS.LOANABLE_VALUES_ROUTE} component={LoanableValues}/>
            <Route path={ROUTES_CONSTANTS.CONTROL_PANEL_ROUTE} component={ControlPanelContainer}/>
            <Route path={ROUTES_CONSTANTS.INVOICE_ROUTE} component={InvoiceContainer}/>
            <Route path={ROUTES_CONSTANTS.CAPTURE_GUARANTEES_ROUTE} component={CaptureGuarantees}/>
            <Route path={ROUTES_CONSTANTS.CORPORATE_ACTION_ROUTE} component={CorporateActionContainer}/>
            <Route path={ROUTES_CONSTANTS.EMAIL_ADMIN_ROUTE} component={EmailAdminContainer}/>
            <Route path={ROUTES_CONSTANTS.TRUST_POSITION_ROUTE} component={TrustPositionContainer}/>
            <Route path={ROUTES_CONSTANTS.CAPACITY_ROUTE} component={CapacityContainer}/>
            <Route path={ROUTES_CONSTANTS.USER_ROUTE} component={UserContainer}/>
            <Route path={ROUTES_CONSTANTS.VALUES_REQUEST_ROUTE} component={ValuesRequest}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_ACCOUNTS_ROUTE} component={MaintenanceAccounts}/>
            <Route path={ROUTES_CONSTANTS.CONTRACT_OTC_ROUTE} component={ContractOTC}/>
            <Route path={ROUTES_CONSTANTS.OPERATION_AMOUNT_ROUTE} component={OperationAmount}/>
            <Route path={ROUTES_CONSTANTS.GUARANTEES_TABLES_ROUTE} component={GuaranteesTables}/>
            <Route path={ROUTES_CONSTANTS.CAPACITY_TABLE_ROUTE} component={CapacityTable}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_INSTITUTIONS_ROUTE} component={MaintenanceInstitutionContainer}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_SCHEDULE_ROUTE} component={MaintenanceSchedule}/>
            <Route path={ROUTES_CONSTANTS.CLIENT_GSS} component={ClientGSS}/>
            <Route path={ROUTES_CONSTANTS.AVAILABLE_LEND} component={AvailableLend}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_USERS_ROUTE} component={MaintenanceUsers}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_DOMAINS_ROUTE} component={MaintenanceDomains}/>
            <Route path={ROUTES_CONSTANTS.CAPTURE_LOANABLE_VALUES_ROUTE} component={CaptureLoanableValues}/>
            <Route path={ROUTES_CONSTANTS.GUARANTEE_SELECTION_ROUTE} component={GuaranteeSelection}/>
            <Route path={ROUTES_CONSTANTS.MAINTENANCE_INSTRUMENT_ROUTE} component={MaintenanceInstrument}/>
            <Route path={ROUTES_CONSTANTS.CUSTODIA_BANAMEX} component={CustodiaBanamex}/>
            <Route path={ROUTES_CONSTANTS.CUSTODIA_BBVA} component={CustodiaBBVA}/>
                <Route path={ROUTES_CONSTANTS.CUSTODIA_TITULOS_MANT} component={CustodiaTitulos}/>
                <Route path={ROUTES_CONSTANTS.BILATERAL_CONTRACT_ROUTE} component={BilateralContract}/>
        </React.Fragment>
    );
};

export default MenuRoutes;